import script from "./ScheduledExcursion.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduledExcursion.vue?vue&type=script&setup=true&lang=js"

import "./ScheduledExcursion.vue?vue&type=style&index=0&id=58528684&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58528684"]])

export default __exports__